import React, { useEffect } from 'react';
import 'antd/dist/antd.css';
import './assets/css/light-theme.css';
import './App.css';
import '../node_modules/react-grid-layout/css/styles.css';
import '../node_modules/react-resizable/css/styles.css';

import store from "./Redux/store";
import Routes from "./Routes";
import { Provider } from "react-redux";
import UseNetwork from "./Services/UseNetwork";
import { saveOnlineStatus, setBotMode } from "./Redux/actions/common";
import { useOrientation } from "./hooks/useOrientation";
import { isMobile } from "react-device-detect";
import ErrorThree from "./Errors/error-page-3";

function App() {
  const [orientation] = useOrientation();
  const networkState = UseNetwork();
  const dispatch = store.dispatch;

  useEffect(() => {
    localStorage.setItem("online", networkState.online ? "online" : "offline");
    dispatch(saveOnlineStatus(networkState.online ? "online" : "offline"));
  }, [networkState.online]);

  useEffect(() => {
    if (process.env.REACT_APP_ENV == "production") {
      console.log = () => {};
    }

    let botMode = localStorage.getItem("bot_mode");
    console.log("BOT MODE", botMode);
    if (!botMode) {
      botMode = "development";
      localStorage.setItem("bot_mode", botMode);
    }
    dispatch(setBotMode(botMode));
  }, []);

  if (isMobile && orientation === "landscape") {
    return (
      <div>
        <ErrorThree />
      </div>
    );
  } else {
    return (
      <Provider store={store}>
        <Routes />
      </Provider>
    );
  }
}

export default App;
